/***
 * 创建人：
 * 时间：2020-12-14
 * 描述：知识库——实体管理主页面 展示数据 查询
 * 可新增 编辑 删除 导入 导出 审核等操作
 * 更新说明:
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { KmsService } from '../../../kms.service';
import { Router, ActivatedRoute,Params } from '@angular/router';
import { SwMassageConfirmComponent } from '../../../../../librarys/components/basic-components/sw-massage-confirm/sw-massage-confirm.component';
import { PlatformLocation } from '@angular/common';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { environment } from 'src/environments/environment';
import { SwGridTableComponent } from 'src/app/librarys/components/basic-components/sw-table/sw-grid-table/sw-grid-table.component';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
declare let $: any;
@Component({
    selector: 'app-instance-query',
    templateUrl: './instance-query.component.html',
    styleUrls: ['./instance-query.component.css']
})
export class InstanceQueryComponent implements OnInit {
    // 批量驳回弹框
    @ViewChild('batchRejectionModal') batchRejectionModal: SwModalframeComponent;
    // 指派弹框
    @ViewChild('appointModal') appointModal: SwModalframeComponent;
    // 分配质检员弹框
    @ViewChild('assignAuditorModal') assignAuditorModal: SwModalframeComponent;
    // 导出质检记录弹框
    @ViewChild('exportRecordModal') exportRecordModal: SwModalframeComponent;
    // 表格组件
    @ViewChild("swtable") swtable: SwGridTableComponent;
    // 删除确认组件
    @ViewChild("tirm1") tirm1: SwMassageConfirmComponent;
    //是否展示左侧菜单
    showLeft: boolean = true  
    // 是否显示内容
    isDatas = {
        conceptLoading: false,  // 概念是否显示加载中
        tableLoading: false  // 表格是否显示加载中
    }
    // 左侧搜索概念名称
    conceptName = '';
    // 左侧搜索概念数据模型
    ontologyTreeDatas = [];
    ontologyTreeDatasCopy = [];
    // 是否展示所有查询条件
    isFormBoxShow = false;
    // 实体表格搜索数据集合
    searchDatas = {
        instanceName: '',      // 实体名称
        approvalStatus: null,  // 状态
        conceptId: '',         // 所属概念
        isRelPicMaterial: null,     // 是否关联图像
        instanceSource: null,      // 来源
        tag:'',                 // 标签名
        createUserId: '',      // 创建人
        editorUserId: '',      // 责任编辑
        checkUserId: '',      // 当前质检员
        onlyMe: false,         // 只看我的
        checkTime: '',         // 质检时间
        checkCommitTime: '',        // 提交质检时间
    }
    // 状态选项
    auditStatus = [
        {id: 6, text: '全部'},{id: 0, text: '待指派'},{id: 1, text: '待编辑'},{id: 2, text: '待分配质检'},
        {id: 3, text: '待质检'},{id:4, text: '待发布'},{id: 5, text: '已发布'}
    ];
    sourceOptions = [
        {id: 6, text: '全部'},{id: 1, text: '录入'},{id: 2, text: '导入'},{id: 3, text: '爬取'},
        {id: 4, text: '知识提取创建'},{id: 5, text: '知识提取编辑'}
    ]
    // 是否关联图像选项
    relateImgOptions = [{id: 2, text: '全部'},{id: 1, text: '是'},{id: 0, text: '否'}];
    // 创建人选项
    creatorOptions: any = [];
    // 编辑人员选项
    editorOptions: any = [];
    // 知识质检人员选项
    auditorOptions: any = [];
    // 用户角色
    userRole = '';
    // 用户id
    userId = '';
    // 表格操作按钮
    toolbarArr = [
        ["add", "batchDelete", "apply", "appoint", "submit", "assignAuditor", "batchRejection", "publish", "republish", "export","clearModelCache","clearInstanceCache"],
        ["modify", "view", "verify", "delete"],
    ];
    toolbar = [[], []];
    // 右侧实体表格数据
    instanceDatas = [];
    // 右侧表格分页组件
    pageBase:any = {
        current: 1,
        size: 10
    }
    // 右侧表格选中行数据
    selectedDatas = [];
    // 批量驳回备注
    rejectionRemark = '';
    // 指定的责任编辑
    editorUserId = '';
    // 指定的质检人员(分配质检员时)
    auditorUserId = '';
    // 指定的质检人员(导出质检记录时)
    auditorUserId1 = '';
    auditTime = '';
    //默认展示的列
    filterDatas: any = {
      instanceName: true,
      conceptName: true,
      fileCount: true,
      relCount: true,
      tags: true,
      approvalStatus: true,
      instanceSource: true,
      createUserName: true,
      editorUserName: true,
      checkUserName: true,
      allCheckUserName: false,
      createDate: true,
      editStartTime: false,
      checkCommitTime: false,
      checkTime: false,
      publishUserName: false,
      publishTime: true,
    }; 
    //筛选dropdown数据
    filterDatasArray: any = [
      { id: "instanceName", text: "实体名称" },
      { id: "conceptName", text: "所属概念" },
      { id: "fileCount", text: "关联资源数量" },
      { id: "relCount", text: "关联关系数量" },
      { id: "tags", text: "标签" },
      { id: "approvalStatus", text: "状态" },
      { id: "instanceSource", text: "来源" },
      { id: "createUserName", text: "创建人" },
      { id: "editorUserName", text: "责任编辑" },
      { id: "checkUserName", text: "当前质检员" },
      { id: "allCheckUserName", text: "所有质检员" },
      { id: "createDate", text: "创建时间" },
      { id: "editStartTime", text: "任务开始时间" },
      { id: "checkCommitTime", text: "提交质检时间" },
      { id: "checkTime", text: "质检时间" },
      { id: "publishUserName", text: "发布人" },
      { id: "publishTime", text: "发布时间" },
    ];
    constructor(
        private location: PlatformLocation,
        private routeInfo: ActivatedRoute,
        private jwt: SwJwtService,
        private User: GetUserModelService, //获取用户服务
        private http: SwHttpClientService,
        private kmsService: KmsService,
        private message: SwMassageBoxService,
        private router: Router
    ) { }

    ngOnInit() {
        // 获取按钮权限
        this.queryToolbarBtns();
        // 获取用户id
        let user = this.User.getUser();
        this.userId = user['userId'];
        // 获取用户角色
        this.userRole = this.jwt.getToken('userRole');
        this.getAllUsers();
        // 根据当前用户角色设置只看我的
        this.setOnlyMe();
        // 获取概念树数据
        this.getOnlogyTreePageList();
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            if(data['selectedData']){
                const params = JSON.parse(data['selectedData']);
                this.searchDatas.approvalStatus = params.approvalStatus;
            }
            // 查询实体列表
            this.getInstanceListDatas();
        });
    }

    // 查询工具按钮列表
    queryToolbarBtns() {
        // 根据路径去查询配置的按钮
        let pathname = ["/", "", ""]
        try {
            pathname = this.location["location"].hash.split('?')[0].split("/");
        } catch (e) {

        }
        let systemId = this.jwt.getToken("systemId")
        // 准备拼接url
        let url = environment.seekerWebAPI + "function/queryButtonsByUri"
        // 要去掉#，故第一个参数不使用
        if (pathname.length > 1) {
            // 拼接uri
            url = url + "?uri=";
            for (let index = 1; index < pathname.length; index++) {
                url = url + "/" + pathname[index]
            }
        }
        // 拼接系统ID参数
        url = url + "&systemId=" + systemId;
        this.http.Post(url, {}).subscribe(data => {
            if (data.code == '200') {
                data.data.forEach((element) => {
                    if (
                        this.toolbarArr[0].filter((item) => item == element.functionCode)
                            .length > 0
                    ) {
                        this.toolbar[0].push({
                            status: true,
                            functionCode: element.functionCode,
                            functionName: element.functionName,
                            icon: element.icon,
                            children: [],
                        });
                    }
                    if (
                        this.toolbarArr[1].filter((item) => item == element.functionCode)
                            .length > 0
                    ) {
                        this.toolbar[1].push({
                            status: true,
                            functionCode: element.functionCode,
                            functionName: element.functionName,
                            icon: element.icon,
                            children: [],
                        });
                    }
                });
            } else {
                this.message.waring('当前用户按钮组权限获取失败！');
            }
        });
    }

    // 根据当前用户角色设置只看我的
    setOnlyMe(){
        if(this.userRole == '知识编辑'){
            this.searchDatas.onlyMe = true;
            this.searchDatas.editorUserId = this.userId;
        }
        if(this.userRole == '知识质检'){
            this.searchDatas.onlyMe = true;
            this.searchDatas.checkUserId = this.userId;
        }
    }

    // 选中或取消选中只看我的
    onlyMeChange(){
        if(this.searchDatas.onlyMe){
            if(this.userRole == '知识编辑'){
                this.searchDatas.editorUserId = this.userId;
            }
            if(this.userRole == '知识质检'){
                this.searchDatas.checkUserId = this.userId;
            }
        }else{
            if(this.userRole == '知识编辑'){
                this.searchDatas.editorUserId = '';
            }
            if(this.userRole == '知识质检'){
                this.searchDatas.checkUserId = '';
            }
        }
        this.handleSearchClick();
    }

    // 表格选中行数据（只根据数据状态判断是否可以进行操作，至于什么角色能够操作由角色权限控制）
    handleSelectData(event) {
        // 获取当前选中的所有数据
        this.selectedDatas = event;
        // 设置按钮组全部启用
        this.swtable.toolbarAllEnable();
        // 未选中任何数据时，启用新增、导出质检记录按钮
        if(this.selectedDatas.length <= 0) {
            this.swtable.toolbarAllDisable();
            this.swtable.enableToobar('add');
            this.swtable.enableToobar('export');
        }else{
            // 禁用批量删除按钮：选中数据中存在已发布的
            let publishedLen = this.selectedDatas.filter(el => el.approvalStatus == 5).length;
            if(publishedLen > 0){
                this.swtable.disableToolbar('batchDelete');
            }
            // 禁用申领按钮：选中数据中存在不是待指派的
            let notAppointLen = this.selectedDatas.filter(el => el.approvalStatus != 0).length;
            if(notAppointLen > 0){
                this.swtable.disableToolbar('apply');
            }
            // 禁用指派按钮：选中数据中存在不是待指派、待编辑、待分配质检、待发布的
            let notAppointLen1 = this.selectedDatas.filter(el => el.approvalStatus != 0 && el.approvalStatus != 1 && el.approvalStatus != 2 && el.approvalStatus != 4).length;
            if(notAppointLen1 > 0){
                this.swtable.disableToolbar('appoint');
            }
            // 禁用提交质检按钮： 选中数据中存在不是待编辑的 或 责任编辑不是当前登录用户的
            let notEditLen  = this.selectedDatas.filter(el => el.approvalStatus != 1).length;
            let notEditorLen  = this.selectedDatas.filter(el => el.editorUserId != this.userId).length;
            if(notEditLen > 0 || notEditorLen > 0){
                this.swtable.disableToolbar('submit');
            }
            // 禁用分配质检员按钮：选中数据中存在不是待分配质检 和 待发布的
            let notAssignLen  = this.selectedDatas.filter(el => el.approvalStatus != 2 && el.approvalStatus != 4).length;
            if(notAssignLen > 0){
                this.swtable.disableToolbar('assignAuditor');
            }
            // 禁用批量驳回按钮：选中数据中存在不是待质检的 或  实体的当前质检员不是当前登录用户的
            let notVerifyLen  = this.selectedDatas.filter(el => el.approvalStatus != 3).length;
            let notAuditorLen  = this.selectedDatas.filter(el => el.checkUserId != this.userId).length;
            if(notVerifyLen > 0 || notAuditorLen > 0){
                this.swtable.disableToolbar('batchRejection');
            }
            // 禁用发布按钮：选中数据中存在不是待发布的
            let notPublishLen  = this.selectedDatas.filter(el => el.approvalStatus != 4).length;
            if(notPublishLen > 0){
                this.swtable.disableToolbar('publish');
            }
            // 禁用撤销发布按钮：选中数据中存在不是已发布的
            let notPublishedLen  = this.selectedDatas.filter(el => el.approvalStatus != 5).length;
            if(notPublishedLen > 0){
                this.swtable.disableToolbar('republish');
            }
        }
    }

    // 表格分页点击方法
    handlePageClick(event) {
        this.pageBase = event;
        this.getInstanceListDatas();
    }

    // 获取左侧概念模型数据
    getOnlogyTreePageList() {
        this.ontologyTreeDatas = [];
        this.isDatas.conceptLoading = true;
        this.kmsService.getConceptTreeData({}).subscribe(
            result => {
                this.isDatas.conceptLoading = false;
                if (result.code == 200) {
                    if (!result.data) {
                        this.ontologyTreeDatas = [];
                        return;
                    }
                    let datas = result.data;
                    this.ontologyTreeDatas = datas;
                    this.ontologyTreeDatasCopy = datas;
                } else {
                    this.message.waring(result.msg);
                }
            }
        )
    }

    // 获取实体表格列表数据
    getInstanceListDatas() {
        this.isDatas.tableLoading = true;
        this.selectedDatas = [];
        let checkStartTime = '';
        let checkEndTime = '';
        if (this.searchDatas.checkTime) {
            checkStartTime = this.searchDatas.checkTime.split('#')[0];
            checkEndTime = this.searchDatas.checkTime.split('#')[1];
        }
        let checkCommitStartTime = '';
        let checkCommitEndTime = '';
        if (this.searchDatas.checkCommitTime) {
            checkCommitStartTime = this.searchDatas.checkCommitTime.split('#')[0];
            checkCommitEndTime = this.searchDatas.checkCommitTime.split('#')[1];
        }
        
        let Params = {
            current: this.pageBase.current,
            size: this.pageBase.size,
            isDelete: false,
            conceptId: this.searchDatas.conceptId,
            instanceName: $.trim(this.searchDatas.instanceName),
            approvalStatus: this.searchDatas.approvalStatus == 6 ? null : this.searchDatas.approvalStatus,
            isRelPicMaterial: this.searchDatas.isRelPicMaterial == 2 ? null : this.searchDatas.isRelPicMaterial,
            instanceSource: this.searchDatas.instanceSource == 6 ? null : this.searchDatas.instanceSource,
            tag: $.trim(this.searchDatas.tag),
            editorUserId: this.searchDatas.editorUserId,
            checkUserId: this.searchDatas.checkUserId,
            createUserId: this.searchDatas.createUserId,
            checkStartTime: checkStartTime,
            checkEndTime: checkEndTime,
            commitCheckStartTime: checkCommitStartTime,
            commitCheckEndTime: checkCommitEndTime,
            orderBy: 1
        };
        this.kmsService.getInstanceQueryList(Params).subscribe(
            result => {
                this.isDatas.tableLoading = false;
                if (result.code == 200) {
                    this.instanceDatas = [];
                    this.pageBase = result.data;
                    this.instanceDatas = result.data.records;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 监听输入框enter键搜索
    handelEnterSearch(event, type) {
        if (event.keyCode == 13) {
            // 搜索概念
            if (type == 0) {
                this.search();
            } 
            // 搜索实体
            else {
                this.handleSearchClick();
            }
        }
    }

    // 搜索实体
    handleSearchClick(){
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.getInstanceListDatas();
    }

    // 概念搜索
    search() {
        if ($.trim(this.conceptName)) {
            this.getConceptNameReturnData();
        } else {
            this.ontologyTreeDatas = this.ontologyTreeDatasCopy;
        }
    }

    // 根据概念名称过滤概念数据
    getConceptNameReturnData() {
        let res = [];
        let newlist = this.ontologyTreeDatasCopy.filter(item => item.name.indexOf($.trim(this.conceptName)) >= 0);
        if (newlist.length === 0) {
            this.ontologyTreeDatas = [];
            return;
        }

        newlist.forEach(item => {
            res = this.getParents(this.ontologyTreeDatasCopy, item, res);
        })
        this.ontologyTreeDatas = res;
    }

    // 根据当前项获取所有父级
    getParents(list, item, parents) {
        if (parents.indexOf(item) == -1) {
            parents.push(item);
        }
        let parentNode = list.filter(el => el.id == item.pid);
        if (parentNode.length == 0) {
            return parents
        } else {
            return this.getParents(list, parentNode[0], parents);
        }
    }

    // 概念选择方法
    handleVotedClick(event) {
        if (!event.data.query) {
            this.message.info('当前节点信息不支持搜索，请重新选择其他的节点进行搜索！');
            return;
        }
        // 表示为概念相关搜索
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.searchDatas.conceptId = event.key;
        this.getInstanceListDatas();
    }

    // 右侧搜索重置按钮
    handleReloadClick() {
        this.pageBase = {
            current: 1,
            size: 10
        }
        this.searchDatas = {
            instanceName: '',      // 实体名称
            approvalStatus: null,  // 状态
            conceptId: '',         // 所属概念
            isRelPicMaterial: null, // 是否关联图像
            instanceSource: null,      // 来源
            tag:'',                 // 标签名
            createUserId: '',      // 创建人
            editorUserId: '',      // 责任编辑
            checkUserId: '',      // 当前质检员
            onlyMe: false,         // 只看我的
            checkTime: '',
            checkCommitTime: ''
        }
        this.getInstanceListDatas();
    }

    // 按钮点击事件
    handleOperationClick(event) {
        switch (event) {
            case "add": this.handleAddClick(); break;                 // 新增
            case "batchDelete": this.handleDeleteClick(); break;      // 批量删除
            case "apply": this.handleApplyClick();break;              // 申领
            case "appoint": this.handleAppointClick();break;          // 指派
            case "submit": this.clickSubmit(); break;                 // 提交质检
            case "assignAuditor": this.clickAssignAuditor(); break;   // 分配质检员
            case "batchRejection": this.clickBatchRejection(); break; // 批量驳回
            case "publish": this.clickPublish(); break;               // 批量发布
            case "republish": this.clickRepublish(); break;           // 撤销发布
            case "export": this.clickExport(); break;                 // 导出质检记录
            case "clearModelCache": this.clickClearModelCache(); break; // 清除模型缓存
            case "clearInstanceCache": this.clickClearInstanceCache(); break; // 清除实例缓存
            default: break;                // 导出质检记录
        }
    }

    // 清除模型缓存
    clickClearModelCache(){
        this.tirm1.openCLick('是否清除模型缓存？', (data) => {
            if (data) {
                this.kmsService.deleteCache(2).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('操作成功！');
                        }
                    }
                )
            }
        })
    }

    // 清除实例缓存
    clickClearInstanceCache(){
        this.tirm1.openCLick('是否清除实例缓存？', (data) => {
            if (data) {
                this.kmsService.deleteCache(1).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('操作成功！');
                        }
                    }
                )
            }
        })
    }

    /**
     * 点击td中的按钮
     * @ignore
     */
    clickTdBtn(type, data) {
        //禁止冒泡
        event.stopPropagation();
        // 编辑
        if (type == 'modify') {
            let selectData = {
                addOrUpdate: 'Edit',
                instanceId: data.instanceId,
                conceptId: data.conceptId,
                conceptName: data.conceptName,
                serialNumber: data.serialNumber,
            };
            this.router.navigate(
                ['/kms/InstanceAdd'],
                { queryParams: { Title: '编辑实体信息', selectData: JSON.stringify(selectData) } }
            );
            // // 测试快速编辑实体
            // this.jwt.setToKen('instanceInfo',JSON.stringify({'upOrAdd': 'Edit','instanceData':data}));
            // $('#quickEditInstance').trigger('click');
        }
        // 查看
        else if (type == "view") {
            let selectData = {
                instanceId: data.instanceId
            };
            this.router.navigate(
                ['/kms/InstanceView'],
                { queryParams: { Title: '查看实体信息', selectData: JSON.stringify(selectData) } }
            );
        }
        // 质检
        else if (type == "verify") {
            let selectData = {
                addOrUpdate: 'Verify',
                instanceId: data.instanceId,
                conceptId: data.conceptId,
                conceptName: data.conceptName,
                serialNumber: data.serialNumber,
            };
            this.router.navigate(
                ['/kms/InstanceAdd'],
                { queryParams: { Title: '审核实体信息', selectData: JSON.stringify(selectData) } }
            );
            // let selectData = {
            //     instanceId: data.instanceId,
            //     state: 'verify'
            // };
            // this.router.navigate(
            //     ['/kms/InstanceView'],
            //     { queryParams: { Title: '实体质检', selectData: JSON.stringify(selectData) } }
            // );
        }
        // 删除
        else if (type == "delete") {
            this.handleDeleteClick(data);
        }
    }

    // 查看实体关联关系、关联资源
    handleToViewInstance(data,tabId){
        let selectData = {
            instanceId: data.instanceId,
            tabId: tabId
        };
        this.router.navigate(
            ['/kms/InstanceView'],
            { queryParams: { Title: '查看实体信息', selectData: JSON.stringify(selectData) } }
        );
    }

    // 新增实体
    handleAddClick() {
        let selectData = {
            addOrUpdate: 'Add',
            conceptId: this.searchDatas.conceptId
        };
        this.router.navigate(['/kms/InstanceAdd'], { queryParams: { Title: '新增实体信息', selectData: JSON.stringify(selectData) } });
    }

    // 删除实体
    handleDeleteClick(item?) {
        let params = [];
        if (item) {
            params = [item.instanceId];
        } else {
            if (this.selectedDatas.length > 0) {
                for (let i = 0; i < this.selectedDatas.length; i++) {
                    params.push(this.selectedDatas[i].instanceId);
                }
            } else {
                this.message.info('请至少选择一条数据！');
                return;
            }
        }
        this.tirm1.openCLick('确认删除吗？', (data) => {
            if (data) {
                this.kmsService.deleteInstanceById(params).subscribe(
                    result => {
                        if (result.code == 200) {
                            this.message.success('操作成功！');
                            this.getInstanceListDatas();
                            // 根据实体标识删除索引记录
                            this.deleteIndexByInstanceId(params);
                        }
                    }
                )
            }
        })
    }

    // 申领
    handleApplyClick(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        let ids = this.selectedDatas.map(v => v.instanceId);
        let params = {
            "dataIds": ids,
            "status": 1
        }
        this.kmsService.batchUpdateEditorAndCheckUser(params).subscribe(res => {
            if(res.code == '200'){
                this.message.info('操作成功！');
                this.getInstanceListDatas();
            }else{
                this.message.waring(res.msg);
            }
        })
    }

    // 指派
    handleAppointClick(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.editorUserId = '';
        this.appointModal.toggle();
    }

    // 提交质检
    clickSubmit() {
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据提交质检？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.instanceId);
                let params = {
                    "approvalStatus": 2,
                    "idList": ids
                }
                this.kmsService.batchUpdateStatus(params).subscribe(res => {
                    if(res.code == '200'){
                        this.message.info('操作成功！');
                        this.getInstanceListDatas();
                    }else{
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 分配质检员
    clickAssignAuditor(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.auditorUserId = '';
        this.assignAuditorModal.toggle();
    }

    // 批量驳回
    clickBatchRejection(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.rejectionRemark = '';
        this.batchRejectionModal.toggle();
    }

    // 发布
    clickPublish(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据进行发布？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.instanceId);
                let params = {
                    "approvalStatus": 5,
                    "idList": ids
                }
                this.kmsService.batchUpdateStatus(params).subscribe(res => {
                    if(res.code == '200'){
                        this.message.info('操作成功！');
                        this.getInstanceListDatas();
                        // 同步索引
                        this.updateInstanceInfoApprovalStatus(5,ids);
                    }else{
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 撤销发布
    clickRepublish(){
        if (this.selectedDatas.length == 0) {
            this.message.danger('请至少选择一条数据！');
            return;
        }
        this.tirm1.openCLick('请确认是否将当前选中的数据撤销发布？', (data) => {
            if (data) {
                let ids = this.selectedDatas.map(v => v.instanceId);
                let params = {
                    "approvalStatus": 4,
                    "idList": ids
                }
                this.kmsService.batchUpdateStatus(params).subscribe(res => {
                    if(res.code == '200'){
                        this.message.info('操作成功！');
                        this.getInstanceListDatas();
                        // 同步索引
                        this.updateInstanceInfoApprovalStatus(4,ids);
                    }else{
                        this.message.waring(res.msg);
                    }
                })
            }
        });
    }

    // 导出质检记录
    clickExport() {
        this.auditorUserId1 = '';
        this.auditTime = '';
        this.exportRecordModal.toggle();
    }

    // 根据实体标识删除索引记录
    deleteIndexByInstanceId(ids) {
        let params = {
            "deleteType": 0,    // 删除类型: 0 逻辑删除 1 物理删除
            "ids": ids,
            "isDelete": 1       // 是否删除: 1 删除 0 不删除
        }
        this.kmsService.deleteIndexByInstanceId(params).subscribe(
            result => {
                if (result.code != 200) {
                    console.log('删除索引失败！');
                }
            }
        )
    }

    // 更新索引实体记录审核状态
    updateInstanceInfoApprovalStatus(approvalStatus, ids) {
        let params = {
            "approvalStatus": approvalStatus,    
            "ids": ids,
        }
        this.kmsService.updateInstanceInfoApprovalStatus(params).subscribe(
            result => {
                if (result.code != 200) {
                    console.log('更新图数据库实体审核状态失败！');
                }
            }
        )
    }

    // 确定操作
    sure(state) {
        let ids = this.selectedDatas.map(v => v.instanceId);
        // 指派
        if(state == 'appoint'){
            let userName = this.editorOptions.filter(el => el.id == this.editorUserId)[0].text;
            let params = {
                "dataIds": ids,
                "status": 1,
                "userId": this.editorUserId,
                "userName": userName
            }
            this.kmsService.batchUpdateEditorAndCheckUser(params).subscribe(res => {
                if(res.code == '200'){
                    this.message.info('操作成功！');
                    this.getInstanceListDatas();
                    this.appointModal.toggle();
                }else{
                    this.message.waring(res.msg);
                }
            })
        }
        // 分配质检员
        if(state == 'assignAuditor'){
            let userName = this.auditorOptions.filter(el => el.id == this.auditorUserId)[0].text;
            let params = {
                "dataIds": ids,
                "status": 3,
                "userId": this.auditorUserId,
                "userName": userName
            }
            this.kmsService.batchUpdateEditorAndCheckUser(params).subscribe(res => {
                if(res.code == '200'){
                    this.message.info('操作成功！');
                    this.getInstanceListDatas();
                    this.assignAuditorModal.toggle();
                }else{
                    this.message.waring(res.msg);
                }
            })
        }
        // 批量驳回
        if(state == 'rejection'){
            let ids = this.selectedDatas.map(v => v.instanceId);
            let params = {
                "approvalStatus": 1,
                "idList": ids,
                "remark": this.rejectionRemark
            }
            this.kmsService.batchUpdateStatus(params).subscribe(res => {
                if(res.code == '200'){
                    this.message.info('操作成功！');
                    this.getInstanceListDatas();
                    this.batchRejectionModal.toggle();
                }else{
                    this.message.waring(res.msg);
                }
            })
        }
        // 导出质检记录
        if(state == 'exportRecord'){
            let startTime = '', endTime = '';
            if(this.auditTime){
                startTime = this.auditTime.split('#')[0],
                endTime = this.auditTime.split('#')[1]
            }
            const params = {
                "recordType": 0,  // 实体质检记录：0，图像标记质检记录：1
                "userId": this.auditorUserId1,
                "startTime": startTime,
                "endTime": endTime
            }
            this.kmsService.exportCheckRecord(params);
            this.exportRecordModal.toggle();
        }
    }

    // 取消操作
    cancel(state) {
        if(state == 'rejection'){
            this.batchRejectionModal.toggle();
        }
        if(state == 'appoint'){
            this.appointModal.toggle();
        }
        if(state == 'assignAuditor'){
            this.assignAuditorModal.toggle();
        }
        if(state == 'exportRecord'){
            this.exportRecordModal.toggle();
        }
    }

    // 左侧概念树切换显示或隐藏
    showStyle(data) {
        this.showLeft = !data;
    }

    // 判断当前数据的操作权限（只根据数据状态判断是否可以进行操作，至于什么角色能够操作由角色权限控制）
    /* 
        禁用编辑按钮：
            1.当前登录用户为超级管理员角色  
            2.当前登录用户为知识库管理员角色且状态为已发布 
            3.当前登录用户为知识编辑角色时，状态不是待编辑或责任编辑不是当前登录用户
            4.当前登录用户为知识质检角色时，状态不是待质检或当前质检员不是当前登录用户
            5.当前登录用户的角色为其他
        禁用质检按钮：状态不是待质检 或 当前登录用户为非知识质检角色  或  当前登录用户不是该实体的当前质检员
        禁用删除按钮：状态为已发布 或 当前登录用户为非知识库管理员角色  
    */
    checkDisable(functionCode,data){
        if(functionCode == 'modify'){
            if(this.userRole == '超级管理员' ||this.userRole == '其他'){
                return true;
            }
            if(this.userRole == '知识库管理员' && data.approvalStatus == 5){
                return true;
            }
            if(this.userRole == '知识编辑' && (data.approvalStatus !== 1 || this.userId != data.editorUserId )){
                return true;
            }
            if(this.userRole == '知识质检' && (data.approvalStatus !== 3 || this.userId != data.checkUserId )){
                return true;
            }
            return false;
        }else if(functionCode == 'view'){
            // 查看按钮任何状态下都不禁用
            return false;
        }else if(functionCode == 'verify'){
            // 知识库管理员可以质检所有待质检实体
            if(this.userRole == '知识库管理员'){
                if(data.approvalStatus != 3){
                    return true;
                }else{
                    return false;
                }
            }else{
                // 禁用质检按钮：数据状态不是待质检  或   当前质检员不是登录用户的
                if(data.approvalStatus != 3 || this.userId != data.checkUserId){
                    return true;
                }else{
                    return false;
                }
            }
        }else if(functionCode == 'delete'){
            // 禁用删除按钮：数据状态为已发布
            if(data.approvalStatus == 5){
                return true;
            }
            return false;
        }
    }

    // 根据用户所属组织id查询所有用户信息、知识编辑人员、知识质检人员
    getAllUsers(){
        let systemId = this.jwt.getToken("systemId");
        // 获取知识库关联组织id(当前为用户所属组织id，需要进行修改)
        let orgId = this.jwt.getToken('orgId');
        let userParams = {
          entity: {
            systemId: systemId
          },
          organizeId: orgId,
          lazy:true,
          param: {
            systemId: systemId, 
            pageNum: 1,
            pageSize: 1000
          }
        }
        this.kmsService.queryUserByOrganizeId(userParams).subscribe(
          data => {
            if(data.code == '200'){
              let res = data.data && data.data.records ? data.data.records : [];
              if(res.length>0){
                res.forEach(el => {
                    el['id'] = el['userId'];
                    el['text'] = el['displayName'];
                    let roleList = el['roleList'];
                    if(roleList && roleList.filter(item => item.roleCode.indexOf('_EDITOR')>=0).length > 0){
                        this.editorOptions.push(el);
                    }else if(roleList && roleList.filter(item => item.roleCode.indexOf('_AUDITOR')>=0).length > 0){
                        this.auditorOptions.push(el);
                    }
                })
                this.creatorOptions = res;
              }
            }
          }
        )
    }

    // 设置查询条件显示/隐藏
    toggleBtn() {
        this.isFormBoxShow = !this.isFormBoxShow;
    }

    // 获取标签名称
    getTagName(tags){
        if(tags){
            let names = tags.map(el => el.tagName);
            return names.join('、');
        }else{
            return '';
        }
    }
}
